const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.eventhouse.in';
// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://styles-questions-ver-mat.trycloudflare.com';

// Get auth token
const getAuthToken = () => {
  return localStorage.getItem('token') ||"";
};

// Common fetch wrapper
const apiFetch = async (endpoint, options = {}) => {
  const token = getAuthToken();
  
  const config = {
    ...options,
    headers: {
      'authorization': `Bearer ${token}`,
      ...options.headers,
    },
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'API request failed');
  }

  return data;
};

// API methods
export const api = {
  // Upload thumbnail
  uploadThumbnail: async (file) => {
    const formData = new FormData();
    formData.append('thumbnail', file);

    return apiFetch('/api/v1/thumbnail', {
      method: 'POST',
      body: formData,
    });
  },

  // Create event
  createEvent: async (eventData) => {
    return apiFetch('/api/v1/event/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
    });
  },

  // Get all events with filters
  getEvents: async (params = {}) => {
    const queryString = new URLSearchParams(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== '')
    ).toString();

    return apiFetch(`/api/v1/event/?${queryString}`, {
      method: 'GET',
    });
  },

  // Get single event
  getEvent: async (id) => {
    return apiFetch(`/api/v1/event/${id}`, {
      method: 'GET',
    });
  },

  // Update event
  updateEvent: async (id, eventData) => {
    return apiFetch(`/api/v1/event/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(eventData),
    });
  },

  // Delete event
  deleteEvent: async (id) => {
    return apiFetch(`/api/v1/event/${id}`, {
      method: 'DELETE',
    });
  },
   getOrdersByEvent: async (params) => {
    const queryString = new URLSearchParams(params).toString();
 

    const response = await fetch(`${API_BASE_URL}/api/v1/admin/event/orders?${queryString}`, {
      method: 'GET',
      headers: {
        'authorization': `Bearer ${getAuthToken()}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch orders');
    }

    return response.json();
  },

  //login user
  loginUser: async (credentials) => {
    return apiFetch('/api/v1/signin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    });
  },

  //signup user
  signupUser: async (userData) => {
    return apiFetch('/api/v1/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(userData),
    });
  },

  //verify signup otp
  verifySignupOtp: async (otpData) => {
    return apiFetch('/api/v1/verifySignup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(otpData),
    });
  },

  //verify login otp
  verifyLoginOtp: async (otpData) => {
    return apiFetch('/api/v1/verifySignin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(otpData),
    });
  },

  //Resend OTP
  resendOtp: async (contactInfo) => {
    return apiFetch('/api/v1/resendOtp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contactInfo),
    });
  },

  //forget password
  forgetPassword: async (emailData) => {
    return apiFetch('/api/v1/forgetPassword', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(emailData),
    });
  },

  //verify forget password otp
  verifyForgetPasswordOtp: async (otpData) => {
    return apiFetch('/api/v1/verify-forget-password', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(otpData),
    });
  },

  //update password
  updatePassword: async (payload) => {
    return apiFetch('/api/v1/update-password', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  },

  //onboarding user
  onboardUser: async (onboardData) => {
    return apiFetch('/api/v1/onboard', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(onboardData),
    });
  },
  
  //onboarding photo upload
  uploadOnboardingImages: async (files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('images', file);
    });
    return apiFetch('/api/v1/images', {
      method: 'POST',
      body: formData,
    });
  },
   
  // get profile
  
  getProfile: async () => {
    return apiFetch('/api/v1/profile', {
      method: 'GET',
    });
  },

  //update profile
  updateProfile: async (profileData) => {
    return apiFetch('/api/v1/update-user', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(profileData),
    });
  },

  //update password from profile
  updateProfilePassword: async (passwordData) => {
    return apiFetch('/api/v1/update-password', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(passwordData),
    });
  },
 
  //uploade profile picture
  uploadProfilePicture: async (file) => {
    const formData = new FormData();
    formData.append('profilePicture', file);
    return apiFetch('/api/v1/profile-picture', {
      method: 'POST',
      body: formData,
    });
  },

   // send query
   sendQuery: async (queryData) => {
    return apiFetch('/api/v1/sendQuery', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(queryData),
    });

   },

   //payment order create 

   createpaymentOrder: async (orderData) => {
    return apiFetch('/api/v1/orders/create', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(orderData),
    })
   },

   // validate coupon
   validateCoupon: async (couponId, payload) => {
    const path = couponId ? `/api/v1/coupon/validate/${couponId}` : '/api/v1/coupon/validate';
    return apiFetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
   },
  
   // delete image

   deleteImage:async (imageId) => {
    return apiFetch(`/api/v1/images/${imageId}`, {
      method: 'DELETE',
    });
   },

   deleteImageByUrl: async (imageUrl) => {
    return apiFetch('/api/v1/image', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ imageUrl }),
    });
   }

 


  
};
